<template>
  <button class="d-flex justify-content-center align-items-center">
    <a :href="shiurim.url_download" target="_blank" @click.prevent="download" download>
      <svg width="100%" height="26px" viewBox="0 0 16 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch -->
        <title>Download Shiur</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="shiur-card-download" transform="translate(1.000000, 0.000000)">
            <polyline id="Path" fill="#0E32B1" points="0.7949 11.5 7.2454 17.8214 13.6958 11.5"></polyline>
            <polygon id="Path" stroke="#0E32B1" stroke-width="2.40816" stroke-linejoin="round" points="0.7949 11.5 7.2454 17.8214 13.6958 11.5"></polygon>
            <path d="M0.7949,24.1429 L13.6958,24.1429" id="Path" stroke="#0E32B1" stroke-width="2.40816" stroke-linecap="round"></path>
            <rect id="Rectangle" fill="#0E32B1" x="5.0952" y="0.9643" width="4.30029" height="10.5357" rx="0.30102"></rect>
          </g>
        </g>
      </svg>
    </a>
  </button>
</template>
<script>
export default {
  props: ['shiurim', 'magidShiur', 'type', 'hideText'],
  methods: {
    download: function () {
      this.$http
        .get('/api/download/' + this.shiurim.id)
        .then(response => {
          ga('send', 'event', 'Audio', 'Download', this.name);
          const url = response.data.filename;
          this.downloadFileUsingURL(url);
        })
        .catch(err => {
          if (!this.$store.state.auth.user.phone_verified_at) {
            this.$store.dispatch('auth/showVerifyNotice');
          }
        });
    },
    downloadFileUsingAnchorTag(url) {
      const link = document.createElement('a');
      link.setAttribute('download', true);
      link.href = url;
      link.setAttribute('id', 'tmpdonwload');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  computed: {
    name: function () {
      var name;
      if (this.type == 'shas') {
        name = this.shiurim.masechta.name + ' ' + this.shiurim.daf;
      } else if (this.type == 'mishna') {
        name = this.$t('KW:mishnaShiurTitle', {
          masechta: this.shiurim.book.name,
          chapter: this.shiurim.mishna_chapter,
          mishna: this.shiurim.mishna_number,
        });
      } else {
        name = this.shiurim.name;
      }
      if (this.magidShiur) {
        name += ' by ' + this.magidShiur.name;
      }
      return name;
    },
  },
};
</script>
